module.exports = "<nv-react-component component=\"CourseAnalytics\"></nv-react-component>";